// @ts-nocheck
/* ============================================
   ESCOLA SEGURA E INTELIGENTE — JavaScript
   ============================================ */

export function initLanding() {
  
    // Initialize Lucide icons
    if (window.lucide) lucide.createIcons();

    initNavbar();
    initScrollAnimations();
    initCounters();
    initParticles();
    /* menu mobile: controlado em React (LandingPage) — evita listeners duplicados no StrictMode */
    initSmoothScroll();
    initLiveFeed();

}

/* --- Navbar Scroll Effect --- */
function initNavbar() {
    const navbar = document.getElementById('navbar');
    const container = document.querySelector('.landing-page') || window;
    let lastScroll = 0;

    container.addEventListener('scroll', () => {
        // Se container for window, usa pageYOffset, senão scrollTop
        const currentScroll = container === window ? window.pageYOffset : (container as HTMLElement).scrollTop;
        navbar?.classList.toggle('scrolled', currentScroll > 80);
        lastScroll = currentScroll;
    });
}

/* --- Smooth Scroll --- */
function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const targetId = this.getAttribute('href');
            if(targetId === '#') return;
            const target = document.querySelector(targetId);
            const container = document.querySelector('.landing-page') || window;
            
            if (target) {
                const offset = 80;
                if (container === window) {
                    const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
                    window.scrollTo({ top, behavior: 'smooth' });
                } else {
                    const top = target.getBoundingClientRect().top + (container as HTMLElement).scrollTop - (container as HTMLElement).getBoundingClientRect().top - offset;
                    (container as HTMLElement).scrollTo({ top, behavior: 'smooth' });
                }
            }
        });
    });
}

/* --- Scroll Animations --- */
function initScrollAnimations() {
    const container = document.querySelector('.landing-page') || null;
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const delay = (entry.target as HTMLElement).dataset.delay || '0';
                setTimeout(() => {
                    entry.target.classList.add('visible');
                }, parseInt(delay));
                observer.unobserve(entry.target);
            }
        });
    }, { 
        root: container,
        threshold: 0.15, 
        rootMargin: '0px 0px -50px 0px' 
    });

    document.querySelectorAll('[data-animate]').forEach(el => observer.observe(el));
}

/* --- Counting Animation --- */
function initCounters() {
    const container = document.querySelector('.landing-page') || null;
    const counterObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                animateCounters(entry.target);
                counterObserver.unobserve(entry.target);
            }
        });
    }, { root: container, threshold: 0.3 });

    // Observe stat containers
    document.querySelectorAll('.hero-stats, .impact-counter').forEach(el => {
        counterObserver.observe(el);
    });
}

function animateCounters(container) {
    const counters = container.querySelectorAll('[data-count]');
    counters.forEach(counter => {
        const target = parseInt(counter.dataset.count);
        const suffix = counter.dataset.suffix || '';
        const duration = 2000;
        const start = performance.now();

        function updateCounter(currentTime) {
            const elapsed = currentTime - start;
            const progress = Math.min(elapsed / duration, 1);
            // Easing: ease-out-expo
            const eased = 1 - Math.pow(1 - progress, 4);
            const current = Math.floor(eased * target);

            counter.textContent = current.toLocaleString('pt-BR') + suffix;

            if (progress < 1) {
                requestAnimationFrame(updateCounter);
            } else {
                counter.textContent = target.toLocaleString('pt-BR') + suffix;
            }
        }
        requestAnimationFrame(updateCounter);
    });
}

/* --- Floating Particles --- */
function initParticles() {
    const container = document.getElementById('heroParticles');
    if (!container) return;

    const particleCount = 30;
    for (let i = 0; i < particleCount; i++) {
        const particle = document.createElement('div');
        particle.style.cssText = `
            position: absolute;
            width: ${Math.random() * 4 + 2}px;
            height: ${Math.random() * 4 + 2}px;
            background: rgba(255,255,255,${Math.random() * 0.15 + 0.05});
            border-radius: 50%;
            left: ${Math.random() * 100}%;
            top: ${Math.random() * 100}%;
            animation: particleFloat ${Math.random() * 8 + 6}s ease-in-out infinite;
            animation-delay: ${Math.random() * 5}s;
        `;
        container.appendChild(particle);
    }

    // Add CSS animation
    if (!document.querySelector('#particleStyles')) {
        const style = document.createElement('style');
        style.id = 'particleStyles';
        style.textContent = `
            @keyframes particleFloat {
                0%, 100% { transform: translate(0, 0) scale(1); opacity: 0.3; }
                25% { transform: translate(${Math.random() * 60 - 30}px, -${Math.random() * 40 + 20}px) scale(1.2); opacity: 0.6; }
                50% { transform: translate(${Math.random() * 40 - 20}px, -${Math.random() * 80 + 40}px) scale(0.8); opacity: 0.4; }
                75% { transform: translate(-${Math.random() * 30 + 10}px, -${Math.random() * 30 + 10}px) scale(1.1); opacity: 0.5; }
            }
        `;
        document.head.appendChild(style);
    }
}

/* --- Hero Notification Vertical Carousel --- */
function initLiveFeed() {
    const carousel = document.getElementById('heroNotifCarousel');
    if (!carousel) return;

    if (window.liveFeedInterval) {
        clearInterval(window.liveFeedInterval);
        window.liveFeedInterval = null;
    }

    const notifications = [
        { icon: '✅', color: 'green',  title: 'Escola Municipal Silva', text: 'Pedro entrou na escola às 07:10', time: 'agora' },
        { icon: '🚌', color: 'blue',   title: 'Transporte Escolar', text: 'Embarque confirmado — Rota Centro', time: '06:52' },
        { icon: '⚠️', color: 'orange', title: 'Alerta de Frequência', text: '3 alunos com risco de evasão identificados', time: '2 min' },
        { icon: '📢', color: 'purple', title: 'Comunicado Oficial', text: 'Reunião de pais confirmada para quinta', time: '5 min' },
        { icon: '📊', color: 'blue',   title: 'Painel Inteligente', text: 'Frequência da turma 5ºB hoje: 96,4%', time: '8 min' },
        { icon: '🔔', color: 'green',  title: 'Saída Registrada', text: 'Ana saiu da escola às 12:05 — mãe autorizou', time: '12 min' },
        { icon: '🛡️', color: 'red',    title: 'Segurança Escolar', text: 'Acesso negado: visitante sem cadastro', time: '15 min' },
        { icon: '📚', color: 'purple', title: 'Agenda Atualizada', text: 'Matemática: Frações equivalentes — Profª Maria', time: '20 min' },
        { icon: '💡', color: 'orange', title: 'IA Educacional', text: 'Sugestão: intervenção pedagógica turma 3ºA', time: '25 min' },
        { icon: '❤️', color: 'green',  title: 'Apoio Social', text: 'Doação de 12 uniformes recebida pela comunidade', time: '30 min' },
    ];

    const VISIBLE = 5; // positions: -2, -1, 0, 1, 2
    const positions = [-2, -1, 0, 1, 2];
    let dataIndex = 0;

    // Clear any previous cards (handles React strict mode double-mount)
    carousel.innerHTML = '';

    // Position lookup — inline styles guarantee correct placement before CSS loads
    const posStyles: Record<string, { y: string; scale: string; op: string }> = {
        '-2': { y: 'calc(-50% - 160px)', scale: '0.84', op: '0.15' },
        '-1': { y: 'calc(-50% - 84px)',  scale: '0.92', op: '0.5'  },
        '0':  { y: '-50%',               scale: '1',    op: '1'    },
        '1':  { y: 'calc(-50% + 84px)',  scale: '0.92', op: '0.5'  },
        '2':  { y: 'calc(-50% + 160px)', scale: '0.84', op: '0.15' },
    };

    // Create card elements with inline positions (no transition, no race condition)
    const cards: { el: HTMLElement; dataIdx: number }[] = [];
    for (let i = 0; i < VISIBLE; i++) {
        const n = notifications[i % notifications.length];
        const p = posStyles[String(positions[i])];
        const el = document.createElement('div');
        el.className = 'hero-notif-card';
        // Position immediately via inline style — CSS will take over after first RAF
        el.style.cssText = `top:50%;transform:translateY(${p.y}) scale(${p.scale});opacity:${p.op};transition:none;`;
        el.innerHTML = `
            <div class="hero-notif-card-icon ${n.color}">${n.icon}</div>
            <div class="hero-notif-card-body">
                <strong>${n.title}</strong>
                <span>${n.text}</span>
            </div>
            <div class="hero-notif-card-time">${n.time}</div>
        `;
        el.dataset.pos = String(positions[i]);
        carousel.appendChild(el);
        cards.push({ el, dataIdx: i });
    }
    dataIndex = VISIBLE;

    // After one frame, remove inline overrides — CSS [data-pos] takes over + transitions enabled
    requestAnimationFrame(() => {
        cards.forEach(card => { card.el.style.cssText = ''; });
    });

    // Cycle every 3 seconds
    window.liveFeedInterval = setInterval(() => {
        // Shift all positions up by 1
        cards.forEach(card => {
            let pos = parseInt(card.el.dataset.pos);
            pos--;

            if (pos < -2) {
                // This card exits top → recycle to bottom with new data
                const n = notifications[dataIndex % notifications.length];
                dataIndex++;
                card.el.querySelector('.hero-notif-card-icon').className = `hero-notif-card-icon ${n.color}`;
                card.el.querySelector('.hero-notif-card-icon').textContent = n.icon;
                card.el.querySelector('.hero-notif-card-body strong').textContent = n.title;
                card.el.querySelector('.hero-notif-card-body span').textContent = n.text;
                card.el.querySelector('.hero-notif-card-time').textContent = n.time;

                // Jump to hidden position (no transition), then animate to pos 2
                card.el.style.transition = 'none';
                card.el.dataset.pos = 'hidden';
                // Force reflow
                card.el.offsetHeight;
                card.el.style.transition = '';
                requestAnimationFrame(() => {
                    card.el.dataset.pos = '2';
                });
            } else {
                card.el.dataset.pos = String(pos);
            }
        });
    }, 3000);
}
